/**
 * A plain left click, which the page answers itself (e.g. by opening the meal pop-up). Anything
 * else — Cmd/Ctrl/Shift/Alt-click — is left to the browser, so the link opens as a link.
 */
export const isPlainLeftClick = (event: MouseEvent) =>
  event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
